import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import classes from "../../Dashboard.module.css";
import { toast } from "react-toastify";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { MenuURLServices } from "../../../../services/dashboard_services";
import { BASE_PATH_TO_MENU_URL_LIST } from "../../../../base_routes_paths/dashboard_paths";
import AUTH_CONTEXT from "../../../../store";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import Loader from "../../../../components/Loader/Loader";

const UpdateMenuUrlConfig = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { token } = AUTH_CONTEXT();
    const [key, setKey] = useState("");
    const [value, setValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [KeyTitle, setKeyTitle] = useState({
        "en-US": "",
        "en-IN": "",
        "en-CA": "",
        "hi-IN": "",
        "ar-AE": ""
    });
    const [isLoaderLoading, setIsLoaderLoading] = useState(false);

    const SubmitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const Data = {
            MenuUrlID: params.ID,
            Data: {
                Key: key,
                Value: value,
                KeyTitle: KeyTitle
            }
        }

        const FetchResponse = async () => {
            try {
                let response = await MenuURLServices.updateMenuURL(token, navigate, Data);

                if (response.status === 207) {
                    return toast
                        .error(response.error, {
                            position: "bottom-left",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                            progress: undefined,
                            theme: "light",
                        })
                }
                setIsLoading(false);
                navigate(BASE_PATH_TO_MENU_URL_LIST);
                toast.success("Data added successfully!!", {
                    position: "bottom-left",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } catch (e) {
                setIsLoading(false);
                toast.error(e.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        };
        FetchResponse();
    };

    const handleKeyTitleChange = (e, locale) => {
        setKeyTitle(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const FetchResponse = async () => {
        try {
            let response = await MenuURLServices.getMenuURLByID(token, navigate, params.ID);
            if (response.status === 207) {
                return toast.error(response.error, {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "light",
                });
            }
            setIsLoaderLoading(true)
            toast.success("Data Fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.log(response)
            return response.data;
        } catch (e) {
            setIsLoaderLoading(false)
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        const FetchData = async () => {
            try {
                let result = await FetchResponse();
                setKeyTitle(result.KeyTitle);
                setKey(result.Key);
                setValue(result.Value);
            } catch (error) {
                console.log(error.message);
            }
        };

        if (params.ID) {
            FetchData();
        } else {
            return;
        }
    }, []);

    return (
        !isLoaderLoading ? <Loader /> : <div className={classes.crumbs}>
            <Breadcrumbs aria-label="breadcrumb" >
                <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                    Dashboard
                </Link>
                <Typography color="text.primary">
                    Dashboard
                </Typography>
                <Typography color="text.primary">Update Menu Url</Typography>
            </Breadcrumbs>
            <Card className={classes.input}>
                <div className={classes.Main_div}>Update Menu Url</div>
                <form onSubmit={SubmitHandler}>
                    <div className={classes.control}>
                        <label htmlFor="Key">Label</label>
                        <input
                            type="text"
                            id="Key"
                            required
                            value={key}
                            onChange={(e) => setKey(e.target.value)}
                            placeholder="Enter Lable name"
                        />
                    </div>
                    <div className={classes.control}>
                        <label htmlFor="Key">Link</label>
                        <input
                            type="text"
                            id="Value"
                            required
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder="Enter link"
                        />
                    </div>

                    <div className={classes.subfields}>
                        <h3>KeyTitle</h3>
                        <div className={classes.subfields}>
                            <div className={classes.control}>
                                <label htmlFor="en-US">KeyTitle (en-US)</label>
                                <input
                                    type="text"
                                    id="en-US"
                                    value={KeyTitle["en-US"]}
                                    onChange={(e) => handleKeyTitleChange(e, "en-US")}
                                    placeholder="Enter KeyTitle for en-US"
                                />
                            </div>
                            <div className={classes.control}>
                                <label htmlFor="en-IN">KeyTitle (en-IN)</label>
                                <input
                                    type="text"
                                    id="en-IN"
                                    value={KeyTitle["en-IN"]}
                                    onChange={(e) => handleKeyTitleChange(e, "en-IN")}
                                    placeholder="Enter KeyTitle for en-IN"
                                />
                            </div>
                            <div className={classes.control}>
                                <label htmlFor="en-CA">KeyTitle (en-CA)</label>
                                <input
                                    type="text"
                                    id="en-CA"
                                    value={KeyTitle["en-CA"]}
                                    onChange={(e) => handleKeyTitleChange(e, "en-CA")}
                                    placeholder="Enter KeyTitle for en-CA"
                                />
                            </div>
                            <div className={classes.control}>
                                <label htmlFor="hi-IN">KeyTitle (hi-IN)</label>
                                <input
                                    type="text"
                                    id="hi-IN"
                                    value={KeyTitle["hi-IN"]}
                                    onChange={(e) => handleKeyTitleChange(e, "hi-IN")}
                                    placeholder="Enter KeyTitle for hi-IN"
                                />
                            </div>
                            <div className={classes.control}>
                                <label htmlFor="ar-AE">KeyTitle (ar-AE)</label>
                                <input
                                    type="text"
                                    id="ar-AE"
                                    value={KeyTitle["ar-AE"]}
                                    onChange={(e) => handleKeyTitleChange(e, "ar-AE")}
                                    placeholder="Enter Description for ar-AE"
                                />
                            </div>
                        </div>
                    </div>
                    {!isLoading && <Button type="submit">Update</Button>}
                    {isLoading && <p color="white">Sending request...</p>}
                </form>
            </Card>
        </div>
    );
};

export default UpdateMenuUrlConfig;
